
import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar } from 'lucide-react';

interface MonthSelectorProps {
  selectedYear: number;
  selectedMonth: number;
  onMonthChange: (year: number, month: number) => void;
  availableMonths?: Array<{ year: number; month: number }>;
}

const MONTHS = [
  'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
  'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];

export const MonthSelector: React.FC<MonthSelectorProps> = ({
  selectedYear,
  selectedMonth,
  onMonthChange,
  availableMonths
}) => {
  // Генерируем доступные месяцы если не переданы
  const getAvailableMonths = () => {
    if (availableMonths) return availableMonths;
    
    const months = [];
    const currentDate = new Date();
    
    // Последние 12 месяцев
    for (let i = 11; i >= 0; i--) {
      const date = new Date(currentDate.getFullYear(), currentDate.getMonth() - i, 1);
      months.push({
        year: date.getFullYear(),
        month: date.getMonth() + 1
      });
    }
    
    return months;
  };

  const months = getAvailableMonths();
  const currentValue = `${selectedYear}-${selectedMonth.toString().padStart(2, '0')}`;

  const handleValueChange = (value: string) => {
    const [year, month] = value.split('-').map(Number);
    onMonthChange(year, month);
  };

  return (
    <div className="flex items-center gap-2">
      <Calendar className="h-4 w-4 text-muted-foreground" />
      <Select value={currentValue} onValueChange={handleValueChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Выберите месяц" />
        </SelectTrigger>
        <SelectContent>
          {months.map(({ year, month }) => {
            const value = `${year}-${month.toString().padStart(2, '0')}`;
            const label = `${MONTHS[month - 1]} ${year}`;
            
            return (
              <SelectItem key={value} value={value}>
                {label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
};
